import {lazy} from './lazy.js';
import {WIDTH, HEIGHT} from 'components/effects/plane/constants.js';

export const spread = (c=1) => {
    return (...args) => {
        let _c = lazy(c, ...args);
        let _coords = {
        };
        let i=0;
        for (let id in args[0]) {
            let coord = args[0][id];
            if (!coord) {
                continue;
            }
            _coords[id] = {
                x: (coord.x + i*_c) % WIDTH,
                y: (coord.y + i*_c) % HEIGHT
            };
            i++;
        }
        return _coords;
    };
};
